var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',[_c('header1'),_c('div',{staticClass:"container content-body"},[_c('div',{domProps:{"innerHTML":_vm._s(_vm.subject.details)}})]),_c('footer1')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }